import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { useEffect, useState } from 'react';

const MenuList_6 = ({ item }) => {
  const [selectedTitle, setSelectedTitle] = useState(null);
  const [children, setChildren] = useState([]);
  const [history, setHistory] = useState([]);
  const [customization, setCustomization] = useState(null);
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  useEffect(() => {
    const convertedCustomization = staticComponentValueConverter(item?.customization);
    setCustomization(convertedCustomization);

    const initialData = item?.customization?.items || [];
    setChildren(initialData);
  }, [item]);

  const handleTitlePress = item => {
    if (item.children && item.children.length > 0) {
      setHistory([...history, { selectedTitle, children }]);
      setSelectedTitle(item.title);
      setChildren(item.children);
    }
  };

  const handleBackPress = () => {
    if (history.length > 0) {
      const previousState = history.pop();
      setSelectedTitle(previousState.selectedTitle);
      setChildren(previousState.children);
      setHistory([...history]);
    } else {
      setSelectedTitle(null);
      const initialData = item?.customization?.items || [];
      setChildren(initialData);
    }
  };

  const renderInitialItem = item => (
    <div key={item.id} style={{ width: '50%', height: 100, padding: 5 }} onClick={() => handleTitlePress(item)}>
      <img
        src={item.image || process.env.REACT_APP_DEFAULT_IMAGE}
        style={{
          width: '100%',
          height: '100%',
          borderRadius: customization?.borderRadius,
          objectFit: customization?.backgroundSize,
        }}
        alt={item.title}
      />
    </div>
  );

  const renderSubItem = item => (
    <div
      key={item.id}
      style={{
        width: '100%',
        borderBottom: `1px solid ${customization?.borderColor}`,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: 60,
        paddingLeft: staticValues[10],
        gap: 10,
      }}
    >
      {item.image && (
        <img
          src={item.image || process.env.REACT_APP_DEFAULT_IMAGE}
          style={{
            borderRadius: customization?.childsBorderRadius,
            objectFit: 'cover',
            width: staticValues[44],
            height: staticValues[44],
          }}
          alt={item.title}
        />
      )}
      <div
        style={{
          flex: 1,
          textAlign: 'left',
          fontSize: customization?.childTextSize,
          fontWeight: customization?.childsTextWeight,
          color: customization?.childTextColor,
        }}
      >
        {item.title}
      </div>
      {item.children && item.children.length > 0 && (
        <div
          style={{ marginRight: staticValues[10] }}
          onClick={e => {
            e.stopPropagation();
            handleTitlePress(item);
          }}
        >
          <svg fill="gray" width="16px" height="16px" viewBox="-2.31 0 15.36 15.36" xmlns="http://www.w3.org/2000/svg">
            <path d="m2.94 13.8 -1.02 -1.02 4.89 -4.92L1.92 2.94l1.02 -1.02 5.88 5.94z" />
          </svg>
        </div>
      )}
    </div>
  );

  return (
    <>
      {customization?.items?.length > 0 ? (
        <div
          style={{
            padding: `${customization?.containerPadding}`,
            backgroundColor: customization?.backgroundType === 'backgroundColor' ? customization?.backgroundColor : '',
            backgroundImage:
              customization?.backgroundType === 'backgroundImage' ? `url(${customization?.backgroundImage})` : '',
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
          }}
          className="pointer-events-auto cursor-pointer"
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              paddingTop: customization?.containerPadding?.[0],
              paddingRight: customization?.containerPadding?.[1],
              paddingBottom: customization?.containerPadding?.[2],
              paddingLeft: customization?.containerPadding?.[3],
            }}
          >
            {selectedTitle && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  borderBottom: `1px solid ${customization?.borderColor}`,
                  paddingTop: staticValues[15],
                  paddingBottom: staticValues[15],
                }}
              >
                <div style={{ marginLeft: staticValues[10] }} onClick={handleBackPress}>
                  <svg width="20px" height="20px" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="48" height="48" fillOpacity="0.01" />
                    <path
                      d="M29 12L17 24L29 36"
                      style={{ stroke: customization?.textColor }}
                      strokeWidth="4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '5px',
                    flex: 1,
                  }}
                >
                  <span
                    style={{
                      fontSize: customization?.textSize,
                      fontWeight: customization?.textWeight,
                      color: customization?.textColor,
                      cursor: 'pointer',
                      maxWidth: 155,
                      // paddingRight: staticValues[20],
                      paddingLeft: customization?.showAllButton === 'show' ? customization?.textSize : 0,
                    }}
                    className="truncate"
                  >
                    {selectedTitle || ''}
                  </span>
                </div>
                {customization?.showAllButton === 'show' ? (
                  <div
                    style={{
                      fontSize: customization?.textSize,
                      fontWeight: customization?.textWeight,
                      color: customization?.textColor,
                      cursor: 'pointer',
                      marginRight: staticValues[10],
                    }}
                  >
                    Tümü
                  </div>
                ) : (
                  <div style={{ width: staticValues[36] }}></div>
                )}
              </div>
            )}

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
              }}
            >
              {children.map(child => (selectedTitle ? renderSubItem(child) : renderInitialItem(child)))}
            </div>
          </div>
        </div>
      ) : (
        <img src={item?.placeholderImage} className={` w-full `} />
      )}
    </>
  );
};

export default MenuList_6;
